<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
  export default {
    name: 'App',
    metaInfo: {
      titleTemplate: '%s | eCommerce development',
      htmlAttrs: {
        lang: 'en'
      },
      meta: [
        { charset: 'utf-8' },
        { 'http-equiv': 'X-UA-Compatible', content: 'IE=edge' },
        { name: 'viewport', content: 'width=device-width,initial-scale=1.0' }
      ],
      link: [
        { rel: 'manifest', href: '/manifest.json' }
      ]
    }
  }
</script> 
<style lang="less">
@import "~@/assets/styles/breakpoints.less";

@font-face {
  font-family: 'LeagueGothicRegular';
  src:  url('~@/assets/fonts/League_Gothic-webfont.woff?zed0sf');
  src:  url('~@/assets/fonts/League_Gothic-webfont.woff?zed0sf#iefix') format('woff');
  font-weight: normal;
  font-style: normal;
}
body {
  background-color: #EFEFEF;
  color: #0F0F0F;
  font: 75%/1.25 Helvetica,Arial,sans-serif;
}
.app {
  margin: 0px auto;
}
@media @for-desktop-up {
  .app {
    width: 1200px
  }
}
</style>
